/*THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 *  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL Galeola S.r.l.( www.galeola.it )(Maxim Postoronca) OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 *  DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 *  OTHER DEALINGS IN THE SOFTWARE.*/
if ( typeof $.fn.dataTable == "function" && typeof $.fn.dataTableExt.fnVersionCheck == "function" && $.fn.dataTableExt.fnVersionCheck('1.9.2')/*older versions should work too*/ )
{
    $.fn.dataTableExt.oApi.clearSearch = function ( oSettings )
    {
 
        var table = this;
         
        //any browser, must include your own file
        //var clearSearch = $('<img src="/images/delete.png" style="vertical-align:text-bottom;cursor:pointer;" alt="Delete" title="Delete"/>');
         
        //no image file needed, css embedding must be supported by browser
       	var clearSearch = $('<img id="searchxpng" alt="" src="'+root+'images/searchx.png" style="padding-right: 6px; opacity: 0"/>');
		
        $(clearSearch).click( function ()
                {
                      $('#datatable_filter input').val('').keyup();
					  $('#searchxpng').css({'opacity':0,'cursor':''});
					  	if($('#searchxpng').css('cursor') == 'text') { console.log('aa'); }
					  
                });
				
        $(oSettings.nTableWrapper).find('div.dataTables_filter').append(clearSearch);
        $(oSettings.nTableWrapper).find('div.dataTables_filter label').css('margin-right', '-20px');//16px the image width
        $(oSettings.nTableWrapper).find('div.dataTables_filter input').css('padding-right', '16px');
		
		if($('#datatable_filter input').val()) { $('#searchxpng').css({'opacity':1,'cursor':'pointer'}); }
		$('#datatable_filter input').keyup(function(){ $('#searchxpng').css({'opacity':1,'cursor':'pointer'}); 
			if($('#datatable_filter input').val() == "") { $('#searchxpng').css({'opacity':0,'cursor':''}); }
		});
    }
 
    //auto-execute, no code needs to be added
    $.fn.dataTable.models.oSettings['aoInitComplete'].push( {
        "fn": $.fn.dataTableExt.oApi.clearSearch,
        "sName": 'clearSearch'
    } );
}

